import { makeStyles } from '@material-ui/core/styles';

import transparentize from '@utils/transparentize';

const useStyles = makeStyles((theme) => ({
  topSection: {
    padding: '40px 0',
    backgroundColor: theme.palette.background.paper,
  },
  guideTitle: {
    margin: '16px 0 8px',
    fontSize: 32,
  },
  loaderWrapper: {
    backgroundColor: theme.palette.background.paper,
    minHeight: 300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  guidePreview: {
    whiteSpace: 'pre-line',
  },
  authorBlock: {
    marginTop: 24,
    display: 'flex',
    alignItems: 'center',
    '& img': {
      marginRight: '0.5ch',
      width: 40,
      height: 40,
      borderRadius: '50%',
      overflow: 'hidden',
    },
  },
  guideDate: {
    paddingLeft: '0.5ch',
    color: theme.palette.info.main,
    '&:before': {
      content: '"•"',
      paddingRight: '0.5ch',
    },
  },
  guideContainer: {
    '& > *:first-child': {
      marginTop: 0,
    },
  },
  guideContent: {
    padding: '40px 0',
    backgroundColor: theme.palette.background.default,
    '& h3': {
      marginBottom: 8,
      marginTop: 0,
    },
    '& h2': {
      marginBottom: 24,
      marginTop: 48,
    },
    '& a': {
      cursor: 'pointer',
      display: 'inline',
      fontWeight: 700,
      color: theme.palette.primary.dark,
    },
    '& li::marker': {
      fontSize: 18,
      color: theme.palette.secondary.dark,
    },
  },
  bottomSection: {
    padding: '40px 0',
    backgroundColor: theme.palette.background.paper,
  },
  nextTip: {
    borderBottomColor: transparentize(theme.palette.info.main, 0.15),
    borderBottomWidth: 2,
    borderBottomStyle: 'solid',
    paddingBottom: 24,
    maxWidth: 450,
  },
  nextTipContent: {
    marginTop: 8,
    display: 'flex',
    justifyContent: 'space-between',
    '& > p': {
      maxWidth: 200,
    },
  },
  alertWrapper: {
    padding: '24px 0 32px',
    borderBottomColor: transparentize(theme.palette.info.main, 0.15),
    borderBottomWidth: 2,
    borderBottomStyle: 'solid',
    maxWidth: 450,
  },
  alertPopup: {
    '& h6': {
      maxWidth: 235,
    },
  },
  alertButton: {
    marginTop: 16,
    padding: '8px 24px',
    borderRadius: 8,
    height: 'unset',
  },
  relatedArticles: {
    maxWidth: 450,
    paddingTop: 24,
  },
  relatedLinks: {
    marginTop: 16,
    display: 'grid',
    rowGap: 8,
    flexDirection: 'column',
  },
  [theme.breakpoints.up('sm')]: {
    topSection: {
      '& h1, p': {
        maxWidth: 450,
      },
    },
    guideContainer: {
      '& > *': {
        maxWidth: 450,
      },
    },
  },
  [theme.breakpoints.up('md')]: {
    guideColumnsWrapper: {
      paddingRight: 0,
      display: 'grid',
      gap: 30,
      marginTop: 16,
      gridTemplateColumns: '5fr 9fr',
    },
    sticky: {
      borderRadius: 16,
      backgroundColor: theme.palette.background.default,
      padding: '32px 0',
      position: 'sticky',
      top: 20,
    },
    headerButton: {
      width: '100%',
      height: 'unset',
      textAlign: 'left',
      border: 'none',
      padding: '16px 24px',
      display: 'block',
      borderRadius: 0,
      transition: 'all 0.3s linear',

      '&.active': {
        position: 'relative',
        backgroundColor: transparentize(theme.palette.primary.main, 0.25),

        '&::before': {
          backgroundColor: theme.palette.primary.dark,
          borderTopRightRadius: 16,
          borderBottomRightRadius: 16,
          content: '""',
          display: 'block',
          height: '100%',
          width: 8,
          position: 'absolute',
          top: 0,
          left: 0,
        },

        '& p': {
          fontWeight: 700,
          color: theme.palette.primary.dark,
        },
      },

      '&:hover': {
        backgroundColor: transparentize(theme.palette.background.paper, 0.5),
      },
    },
  },
  [theme.breakpoints.up('lg')]: {
    guideColumnsWrapper: {
      gap: 125,
    },
    sticky: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: 16,
      '&:after': {
        backgroundColor: transparentize(theme.palette.info.main, 0.3),
        content: '""',
        position: 'absolute',
        top: 0,
        display: 'block',
        right: -62,
        width: 1,
        height: '100%',
      },
    },
  },
}));

export default useStyles;
